<template>
  <el-card shadow="never" class="aui-card--fill">
     <div class="mod-home" >
      <div class="home_title" style="margin:30px auto">今日统计</div>
      <div class="user_pa">
        <div class="today_num">
          <div class="pa_title">今日订单新增总数</div>
          <div class="pa_num">{{nowIncrease.increaseSum}}</div>
        </div>
        <div class="today_num">
          <div class="pa_title">今日释放优果总数</div>
          <div class="pa_num">{{nowIncrease.releaseIntegrationSum}}</div>
        </div>
        <div class="today_num">
          <div class="pa_title">今日新增用户总数</div>
          <div class="pa_num">{{nowIncrease.increaseUser}}</div>
        </div>
        <div class="today_num">
          <div class="pa_title">今日新增云客总数</div>
          <div class="pa_num">{{nowIncrease.increaseYunSum}}</div>
        </div>
      </div>
    </div>
     <div class="mod-home" style="margin-top:80px">
      <div class="home_title">寄售订单</div>
      <div
        style="margin:50px auto"
        class="chart_pa"
        id="myChart4"
        :style="{width: '600px', height: '300px'}"
      ></div>
    </div>
    <div class="mod-home" style="margin-top:80px">
      <div class="home_title">数据统计</div>
      <div class="user_pa">
        <div class="chart_pa" id="myChart1" :style="{width: '220px', height: '280px'}"></div>
        <div class="chart_pa" id="myChart2" :style="{width: '220px', height: '280px'}"></div>
        <div class="chart_pa" id="myChart3" :style="{width: '220px', height: '280px'}"></div>
        <div class="chart_pa" id="myChart5" :style="{width: '220px', height: '280px'}"></div>
      </div>
      <div class="chart_map" id="map" :style="{width: '600px', height: '450px'}"></div>
    </div>
  </el-card>
</template>

<script>
export default {
  data() {
    return {
      sysInfo: {
        osName: "",
        osVersion: "",
        osArch: "",
        processors: 0,
        totalPhysical: 0,
        freePhysical: 0,
        memoryRate: 0,
        userLanguage: "",
        jvmName: "",
        javaVersion: "",
        javaHome: "",
        userDir: "",
        javaTotalMemory: 0,
        javaFreeMemory: 0,
        javaMaxMemory: 0,
        userName: "",
        systemCpuLoad: 0,
        userTimezone: ""
      },
      homePageData: {
        integrationBalanceSum: "",
        integrationLockSum: "",
        integrationDeviceSum: "",
        cashBalanceSum: "",
        saveHereSum:""
      },
      charts: "",
      nowIncrease: {
        increaseSum: "", //今日新增订单
        releaseIntegrationSum: "", //今日释放优果总量
        increaseUser: "", //今日新增用户总数
        increaseYunSum: "" //今日新增云客总数
      },
      sum: {
        directorSum: "", //董事
        juridicalSum: "", //法人
        partnerSum: "", //合伙人
        youKeSum: "", //优客
        yunKeSum: "" //云客
      },
      you: {
        cashBalanceSum: "", //现金余额
        cashLockSum: "", //锁定现金
        integrationBalanceSum: "", //优果余额
        integrationDeviceSum: "", //设备优果
        saveHereSum:"",//注册优果
        integrationLockSum: "", //锁定优果
        destroyintegrationSum:"",//已销毁优果
      },
      exchange: {
        matchOrderSum: "", //匹配订单总数
        platformOrderSum: "", //银商订单总数
        premiumOrderSum: "" //溢价订单总数
      },
      area: {
        anhui: "", //安徽
        beijin: "", //北京
        chongqing: "", //重庆
        fujian: "", //福建
        gansu: "", //甘肃
        guangdong: "", //广东
        guangxi: "", //广西
        guizhou: "", //贵州
        hainan: "", //海南
        hebei: "", //河北
        heilongjiang: "", //黑龙江,
        henan: "", //河南
        hubei: "", //湖北
        hunan: "", //湖南
        jiangsu: "", //江苏
        jiangxi: "", //江西
        jilin: "", //吉林
        liaoning: "", //辽宁
        ningxia: "", //宁夏
        nmg: "", //内蒙古
        qinghai: "", //青海
        shandong: "", //山东
        shanghai: "", //上海
        shanxi: "", //山西
        sichuan: "", //四川
        tianjin: "", //天津
        xinjiang: "", //新疆
        xizang: "", //西藏
        yunnan: "", //云南
        zhejiang: "", //浙江
        zizhiqu: "" //自治区
      }
    };
  },
  created() {
    this.getSysInfo();
    this.getOrderInfo();
    this.getUserInfo();
    this.getYouInfo();
    this.getExchange();
  },
  mounted() {
    // this.drawPie1();
    // this.drawPie2();
    // this.drawPie3();
    // this.drawPie4();
    // this.map();
  },
  methods: {
    //获取订单信息
    getOrderInfo() {
      this.$http
        .get(`/oms/order/getHomePageData`)
        .then(({ data: res }) => {
          if (res.code == 0) {
            this.nowIncrease.increaseSum = res.data.increaseSum;
            this.nowIncrease.releaseIntegrationSum =
              res.data.releaseIntegrationSum;
            this.sum.orderSum = res.data.orderSum;
            this.drawPie2();
          }
        })
        .catch(() => {});
    },
    //获取会员信息
    getUserInfo() {
      this.$http
        .get(`/pms/umsmember/getHomePageData`)
        .then(({ data: res }) => {
          if (res.code == 0) {
            this.nowIncrease.increaseUser = res.data.increaseUser;
            this.nowIncrease.increaseYunSum = res.data.increaseYunSum;
            this.sum.directorSum = res.data.directorSum;
            this.sum.juridicalSum = res.data.juridicalSum;
            this.sum.partnerSum = res.data.partnerSum;
            this.sum.youKeSum = res.data.youKeSum;
            this.sum.yunKeSum = res.data.yunKeSum;
            (this.area.anhui = res.data.anhui), //安徽
              (this.area.beijin = res.data.beijin), //北京
              (this.area.chongqing = res.data.chongqing), //重庆
              (this.area.fujian = res.data.fujian), //福建
              (this.area.gansu = res.data.gansu), //甘肃
              (this.area.guangdong = res.data.guangdong), //广东
              (this.area.guangxi = res.data.guangxi), //广西
              (this.area.guizhou = res.data.guizhou), //贵州
              (this.area.hainan = res.data.henan), //海南
              (this.area.hebei = res.data.hebei), //河北
              (this.area.heilongjiang = res.data.heilongjiang), //黑龙江,
              (this.area.henan = res.data.henan), //河南
              (this.area.hubei = res.data.hubei), //湖北
              (this.area.hunan = res.data.hunan), //湖南
              (this.area.jiangsu = res.data.jiangsu), //江苏
              (this.area.jiangxi = res.data.jiangxi), //江西
              (this.area.jilin = res.data.jilin), //吉林
              (this.area.liaoning = res.data.liaoning), //辽宁
              (this.area.ningxia = res.data.ningxia), //宁夏
              (this.area.nmg = res.data.nmg), //内蒙古
              (this.area.qinghai = res.data.qinghai), //青海
              (this.area.shandong = res.data.shandong), //山东
              (this.area.shanghai = res.data.shanghai), //上海
              (this.area.shanxi = res.data.shanxi), //山西
              (this.area.sichuan = res.data.sichuan), //四川
              (this.area.tianjin = res.data.tianjin), //天津
              (this.area.xinjiang = res.data.xinjiang), //新疆
              (this.area.xizang = res.data.xizang), //西藏
              (this.area.yunnan = res.data.yunnan), //云南
              (this.area.zhejiang = res.data.zhejiang), //浙江
              this.drawPie1();
              this.drawPie5();
            this.map();
          }
        })
        .catch(() => {});
    },
    getSysInfo() {
      this.$http
        .get("/sys/info")
        .then(({ data: res }) => {
          if (res.code !== 0) {
            return this.$message.error(res.msg);
          }
          this.sysInfo = res.data;
        })
        .catch(() => {});
    },
    //获取优果信息
    getYouInfo() {
      this.$http
        .get(`/ums/memberbalance/getHomePageData`)
        .then(({ data: res }) => {
          if (res.code == 0) {
            this.you.cashBalanceSum = res.data.cashBalanceSum;
            this.you.cashLockSum = res.data.cashLockSum;
            this.you.integrationBalanceSum = res.data.integrationBalanceSum;
            this.you.integrationDeviceSum = res.data.integrationDeviceSum;
            this.you.saveHereSum = res.data.saveHereSum
            this.you.integrationLockSum = res.data.integrationLockSum;
            this.you.destroyintegrationSum = res.data.destroyintegrationSum
            this.drawPie3();
          }
        })
        .catch(() => {});
    },
    //获取寄售订单
    getExchange() {
      this.$http
        .get(`/csm/matching/getHomePageData`)
        .then(({ data: res }) => {
          if (res.code == 0) {
            this.exchange.matchOrderSum = res.data.matchOrderSum;
            this.exchange.platformOrderSum = res.data.platformOrderSum;
            this.exchange.premiumOrderSum = res.data.premiumOrderSum;
            this.drawPie4();
          }
        })
        .catch(() => {});
    },
    drawPie1() {
      // 基于准备好的dom，初始化echarts实例
      let myChart = this.$echarts.init(document.getElementById("myChart1"));
      // 绘制图表
      myChart.setOption({
        // backgroundColor: "#ffffff",

        title: {
          text: "注册用户数",
          left: "center",
          top: 20,
          textStyle: {
            color: "#ffffff",
            fontSize: 12
          }
        },

        tooltip: {
          trigger: "item",
          formatter: "{a} <br/>{b} : {c} ({d}%)"
        },
        color: ["#f845f1", "#ad46f3", "#5045f6", "#4777f5", "#44aff0"],
        series: [
          {
            name: "注册用户数",
            type: "pie",
            radius: "50%",
            center: ["50%", "50%"],
            data: [
              {
                value: this.sum.youKeSum,
                name: "优客"
              },
              {
                value: this.sum.yunKeSum,
                name: "云客"
              },
              {
                value: this.sum.partnerSum,
                name: "合伙人"
              },
              {
                value: this.sum.directorSum,
                name: "董事"
              },
              {
                value: this.sum.juridicalSum,
                name: "法人"
              }
            ]
          }
        ]
      });
    },
    drawPie2() {
      // 基于准备好的dom，初始化echarts实例
      let myChart = this.$echarts.init(document.getElementById("myChart2"));
      // 绘制图表
      myChart.setOption({
        title: {
          text: "订单总数(已付款)",
          x: "center",
          top: 20,
          textStyle: {
            color: "#ffffff",
            fontSize: 12
          }
        },
        tooltip: {
          trigger: "item",
          formatter: "{a} <br/>{b} : {c} ({d}%)"
        },
        color: ["#f5c847", "#f36f8a"],
        series: [
          {
            name: "订单总数",
            type: "pie",
            radius: "55%",
            center: ["50%", "50%"],
            data: [
            //   { value: 335, name: "已完成" },
              { value: this.sum.orderSum, name: "已付款" }
            ],
            itemStyle: {}
          }
        ]
      });
    },
    drawPie3() {
      // 基于准备好的dom，初始化echarts实例
      let myChart = this.$echarts.init(document.getElementById("myChart3"));
      // 绘制图表
      myChart.setOption({
        title: {
          text: "优果总数",
          x: "center",
          top: 20,
          textStyle: {
            color: "#ffffff",
            fontSize: 12
          }
        },
        tooltip: {
          trigger: "item",
          formatter: "{a} <br/>{b}: {c} ({d}%)"
        },
        color: ["#4ac7f5", "#0089ff", "#f36f8a","#ffffff"],
        series: [
          {
            name: "优果总数",
            type: "pie",
            radius: ["50%", "60%"],
            avoidLabelOverlap: false,
            label: {
              normal: {
                show: false,
                position: "center"
              },
              emphasis: {
                show: true,
                textStyle: {
                  fontSize: "30",
                  fontWeight: "bold"
                }
              }
            },
            labelLine: {
              normal: {
                show: false
              }
            },
            data: [
              //     cashBalanceSum: "", //现金余额
              //     cashLockSum: "", //锁定现金
              //     integrationBalanceSum: "", //优果余额
              //     integrationDeviceSum: "", //设备优果
              //     integrationLockSum: "" //锁定优果
              { value: this.you.integrationBalanceSum, name: "账户优果" },
              { value: this.you.integrationLockSum, name: "锁定优果" },
              { value: this.you.integrationDeviceSum, name: "注册优果" },
              { value: this.you.saveHereSum, name: "设备优果" }
            ]
          }
        ]
      });
    },
    drawPie4() {
      // 基于准备好的dom，初始化echarts实例
      var colors = ["#5793f3", "#d14a61", "#675bba"];
      let myChart = this.$echarts.init(document.getElementById("myChart4"));
      // 绘制图表
      myChart.setOption({
        color: ["#3398DB"],
        tooltip: {
          trigger: "axis",
          axisPointer: {
            // 坐标轴指示器，坐标轴触发有效
            type: "shadow" // 默认为直线，可选为：'line' | 'shadow'
          }
        },
        grid: {
          left: "3%",
          right: "4%",
          bottom: "3%",
          containLabel: true
        },
        xAxis: [
          {
            type: "category",
            data: ["匹配中的订单总数", "银商订单总数", "溢价订单总数"],
            // axisTick: {
            //   alignWithLabel: true
            // }
            axisLabel: {
              //字体样式
              show: true,
              textStyle: {
                color: "#ffffff",
                fontSize: 14 //文字的字体大小
              }
            }
          }
        ],
        yAxis: [
          {
            type: "value",
            axisLabel: {
              //字体样式
              show: true,
              textStyle: {
                color: "#ffffff",
                fontSize: 14 //文字的字体大小
              }
            }
          }
        ],
        color: ["#83bff6"],
        series: [
          {
            name: "寄售订单",
            type: "bar",
            barWidth: "30%",
            data: [
              this.exchange.matchOrderSum,
              this.exchange.platformOrderSum,
              this.exchange.premiumOrderSum
            ]
          }
        ]
      });
    },
    drawPie5(){
       // 基于准备好的dom，初始化echarts实例
      let myChart = this.$echarts.init(document.getElementById("myChart5"));
      // 绘制图表
      myChart.setOption({
        title: {
          text: "已销毁优果",
          x: "center",
          top: 20,
          textStyle: {
            color: "#ffffff",
            fontSize: 12
          }
        },
        tooltip: {
          trigger: "item",
          formatter: "{a} <br/>{b} : {c} ({d}%)"
        },
        color: ["#f36f8a"],
        series: [
          {
            name: "订单总数",
            type: "pie",
            radius: "55%",
            center: ["50%", "50%"],
            data: [
            //   { value: 335, name: "已完成" },
              { value: this.you.destroyintegrationSum, name: "已销毁优果" }
            ],
            itemStyle: {}
          }
        ]
      });
    },
    // { value: this.you.destroyintegrationSum, name: "已销毁优果" },
    map() {
      var myChart = this.$echarts.init(document.getElementById("map"));
      var nameColor = " rgb(55, 75, 113)";
      var name_fontFamily = "宋体";
      var name_fontSize = 35;
      var mapName = "china";
      var data = [
        { name: "北京", value: this.area.beijin },
        { name: "天津", value: this.area.tianjin },
        { name: "上海", value: this.area.shanghai },
        { name: "重庆", value: this.area.chongqing },
        { name: "河北", value: this.area.hebei },
        { name: "河南", value: this.area.henan },
        { name: "云南", value: this.area.yunnan },
        { name: "辽宁", value: this.area.liaoning },
        { name: "黑龙江", value: this.area.heilongjiang },
        { name: "湖南", value: this.area.hunan },
        { name: "安徽", value: this.area.anhui },
        { name: "山东", value: this.area.shandong },
        { name: "新疆", value: this.area.xinjiang },
        { name: "江苏", value: this.area.jiangsu },
        { name: "浙江", value: this.area.zhejiang },
        { name: "江西", value: this.area.jiangxi },
        { name: "湖北", value: this.area.hubei },
        { name: "广西", value: this.area.guangxi },
        { name: "甘肃", value: this.area.gansu },
        { name: "山西", value: this.area.shanxi },
        { name: "内蒙古", value: this.area.nmg },
        { name: "陕西", value: this.area.shanxi },
        { name: "吉林", value: this.area.jilin },
        { name: "福建", value: this.area.fujian },
        { name: "贵州", value: this.area.guizhou },
        { name: "广东", value: this.area.guangdong },
        { name: "青海", value: this.area.qinghai },
        { name: "西藏", value: this.area.xizang },
        { name: "四川", value: this.area.sichuan },
        { name: "宁夏", value: this.area.ningxia },
        { name: "海南", value: this.area.hainan }
        // { name: "台湾", value: this.area.tai },
        // { name: "香港", value: randomValue() },
        // { name: "澳门", value: randomValue() }
      ];
      var geoCoordMap = {};
      var toolTipData = [];
      console.log(data);
      /*获取地图数据*/
      myChart.showLoading();
      var mapFeatures = this.$echarts.getMap(mapName).geoJson.features;
      myChart.hideLoading();
      for (var i = 0; i < data.length; i++) {
        toolTipData.push({
          name: data[i].name,
          value: [
            {
              name: "实名用户",
              value: data[i].value + "人"
            }
          ]
        });
      }
      //   mapFeatures.forEach(function(v) {
      //     // 地区名称
      //     var name = v.properties.name;
      //     // 地区经纬度
      //     geoCoordMap[name] = v.properties.cp;
      //     data.push({
      //       name: name,
      //       value: Math.round(Math.random() * 100 + 10)
      //     });
      //     toolTipData.push({
      //       name: name,
      //       value: [
      //         {
      //           name: "实名用户",
      //           value: Math.round(Math.random() * 100 + 10) + "人"
      //         }
      //       ]
      //     });
      //   });

      var max = 480,
        min = 9; // todo
      var maxSize4Pin = 50,
        minSize4Pin = 20;

      var convertData = function(data) {
        var res = [];
        for (var i = 0; i < data.length; i++) {
          var geoCoord = geoCoordMap[data[i].name];
          if (geoCoord) {
            res = [
              {
                name: data[i].name,
                value: geoCoord.concat(data[i].value)
              }
            ];
          }
        }
        return res;
      };

      var option = {
        title: {
          text: "已实名认证用户的地域分布",
          x: "center",
          top: 20,
          textStyle: {
            color: "#ffffff",
            fontSize: 12
          }
        },
        tooltip: {
          trigger: "item",
          formatter: function(params) {
            if (typeof params.value[2] == "undefined") {
              var toolTiphtml = "";
              for (var i = 0; i < toolTipData.length; i++) {
                if (params.name == toolTipData[i].name) {
                  toolTiphtml += toolTipData[i].name + ":<br>";
                  for (var j = 0; j < toolTipData[i].value.length; j++) {
                    toolTiphtml +=
                      toolTipData[i].value[j].name +
                      ":" +
                      toolTipData[i].value[j].value +
                      "<br>";
                  }
                }
              }
              console.log(toolTiphtml);
              return toolTiphtml;
            } else {
              var toolTiphtml = "";
              for (var i = 0; i < toolTipData.length; i++) {
                if (params.name == toolTipData[i].name) {
                  toolTiphtml += toolTipData[i].name + ":<br>";
                  for (var j = 0; j < toolTipData[i].value.length; j++) {
                    toolTiphtml +=
                      toolTipData[i].value[j].name +
                      ":" +
                      toolTipData[i].value[j].value +
                      "<br>";
                  }
                }
              }
              console.log(toolTiphtml);
              return toolTiphtml;
            }
          }
        },
        legend: {
          orient: "vertical",
          y: "bottom",
          x: "right",
          data: ["credit_pm2.5"],
          textStyle: {
            color: "#fff"
          }
        },
        visualMap: {
          show: false,
          min: 0,
          max: 600,
          left: "left",
          top: "bottom",
          text: ["高", "低"], // 文本，默认为数值文本
          calculable: true,
          seriesIndex: [1],
          inRange: {
            // color: ['#3B5077', '#031525'] // 蓝黑
            // color: ['#ffc0cb', '#800080'] // 红紫
            // color: ['#3C3B3F', '#605C3C'] // 黑绿
            //  color: ['#0f0c29', '#302b63', '#24243e'] // 黑紫黑
            // color: ['#23074d', '#cc5333'] // 紫红
            //   color: ['#00467F', '#A5CC82'] // 蓝绿
            // color: ['#1488CC', '#2B32B2'] // 浅蓝
            // color: ['#00467F', '#A5CC82','#ffc0cb'] // 蓝绿红
            // color: ['#00467F', '#A5CC82'] // 蓝绿
            // color: ['#00467F', '#A5CC82'] // 蓝绿
            // color: ['#00467F', '#A5CC82'] // 蓝绿
            color: ["#22e5e8", "#0035f9", "#22e5e8"] // 蓝绿
          }
        },
        /*工具按钮组*/
        toolbox: {
          show: false,
          orient: "vertical",
          left: "right",
          top: "center",
          feature: {
            dataView: {
              readOnly: false
            },
            restore: {},
            saveAsImage: {}
          }
        },
        geo: {
          show: true,
          map: mapName,
          label: {
            normal: {
              show: false
            },
            emphasis: {
              show: false
            }
          },
          roam: true,
          itemStyle: {
            normal: {
              areaColor: "#031525",
              borderColor: "#097bba"
            },
            emphasis: {
              areaColor: "#2B91B7"
            }
          }
        },
        series: [
          {
            name: "散点",
            type: "scatter",
            coordinateSystem: "geo",
            data: convertData(data),
            symbolSize: function(val) {
              return val[2] / 10;
            },
            label: {
              normal: {
                formatter: "{b}",
                position: "right",
                show: false
              },
              emphasis: {
                show: false
              }
            },
            itemStyle: {
              normal: {
                color: "rgba(255,255,0,0.8)"
              }
            }
          },
          {
            type: "map",
            map: mapName,
            geoIndex: 0,
            aspectScale: 0.75, //长宽比
            showLegendSymbol: false, // 存在legend时显示
            label: {
              normal: {
                show: true
              },
              emphasis: {
                show: false,
                textStyle: {
                  color: "#fff"
                }
              }
            },
            roam: true,
            itemStyle: {
              normal: {
                areaColor: "#031525",
                borderColor: "#3B5077"
              },
              emphasis: {
                areaColor: "#2B91B7"
              }
            },
            animation: false,
            data: data
          },
          {
            name: "点",
            type: "scatter",
            coordinateSystem: "geo",
            symbol: "pin", //气泡
            symbolSize: function(val) {
              var a = (maxSize4Pin - minSize4Pin) / (max - min);
              var b = minSize4Pin - a * min;
              b = maxSize4Pin - a * max;
              return a * val[2] + b;
            },
            label: {
              normal: {
                show: false,
                formatter: function(params) {
                  return params.data.value[2];
                },
                textStyle: {
                  color: "#fff",
                  fontSize: 9
                }
              }
            },
            itemStyle: {
              normal: {
                color: "rgba(255,255,0,0)" //标志颜色
              }
            },
            zlevel: 6,
            data: convertData(data)
          },
          {
            name: "Top 5",
            type: "effectScatter",
            coordinateSystem: "geo",
            data: convertData(
              data
                .sort(function(a, b) {
                  return b.value - a.value;
                })
                .slice(0, 5)
            ),
            symbolSize: function(val) {
              return val[2] / 10;
            },
            showEffectOn: "render",
            rippleEffect: {
              brushType: "stroke"
            },
            hoverAnimation: true,
            label: {
              normal: {
                formatter: "{b}",
                position: "right",
                show: true
              }
            },
            itemStyle: {
              normal: {
                color: "rgba(255,255,0,0.8)",
                shadowBlur: 10,
                shadowColor: "#05C3F9"
              }
            },
            zlevel: 1
          }
        ]
      };

      // 使用刚指定的配置项和数据显示图表。
      myChart.setOption(option);
      window.addEventListener("resize", function() {
        myChart.resize();
      });
    }
  }
};
</script>
<style scoped>
.el-card >>> .el-card__body {
  background: url("../../assets/img/map_bg.png");
}
.user_pa {
  margin-top: 20px;
  display: flex;
  justify-content: space-around;
}
.chart_pa {
  /* background: #3B5077; */
  background: rgba(0, 24, 106, 0.5);
  border: 1px solid #20558b;
}
canvas {
  padding: 10px !important;
}
.mod-home {
  margin-top: 20px;
}
.today_num {
  padding: 20px 10px;
  width: 220px;
  height: 100px;
  background: rgba(0, 24, 106, 0.5);
  border: 1px solid #20558b;
}
.pa_title {
  font-size: 16px;
  color: #ffffff;
  text-align: center;
  /* font-weight: bold; */
}
.pa_num {
  margin-top: 15px;
  font-size: 22px;
  color: #ffffff;
  text-align: center;
  /* font-weight: bold; */
}
.home_title {
  text-align: center;
  font-size: 20px;
  font-weight: bold;
  color: #f5eaea;
}
.chart_map {
  margin: 20px auto;
  /* background: #3B5077; */
}
</style>
